
import { Challenge } from '../../types/game';
import { skills } from '../skills';

export const regulatoryCrackdownChallenge: Challenge = {
  id: 'regulatory-crackdown',
  title: 'Regulatory Crackdown',
  description: "Local authorities have implemented new regulations on energy consumption. What is your approach?",
  options: [
    {
      text: 'Comply fully and adjust operations',
      outcome: 'Compliance increased costs but protected your reputation and long-term operations.',
      kpiEffects: {
        energyCost: 0.015,
        profitMargin: -2
      },
      experienceGain: 15
    },
    {
      text: 'Relocate operations to a more favorable jurisdiction',
      outcome: 'Relocation was costly but secured better long-term operating conditions.',
      kpiEffects: {
        uptime: -5,
        profitMargin: -7,
        energyCost: -0.02
      },
      experienceGain: 30,
      skillUnlock: skills.find(s => s.id === 'regulatory-compliance')!
    },
    {
      text: 'Negotiate with authorities and propose compromises',
      outcome: 'Your negotiations resulted in modified regulations that you can work with.',
      kpiEffects: {
        energyCost: 0.005
      },
      experienceGain: 25,
      skillUnlock: skills.find(s => s.id === 'negotiation')!
    }
  ],
  difficulty: 4
};
